<div class="social-wall-widget animate__animated" [ngClass]="animation()" [style.animationDelay.ms]="animationDelay()">
  @if (title() || (channelList()?.length || 0) > 1) {
    <div class="social-wall-widget__header">
      @if (title()) {
        <div class="social-wall-widget__title">{{ title() }}</div>
      }
      @if ((channelList()?.length || 0) > 1) {
        <div class="social-wall-widget__channel-list">
          @for (channel of channelList(); track channel.id) {
            <div
              class="social-wall-widget__channel"
              [class.active]="channel.id === selectedChannel()?.id"
              (click)="selectChannel(channel)">
              {{ channel.title }}
            </div>
          }
        </div>
      }
    </div>
  }

  <lib-social-wall
    [channel]="selectedChannel()?.id"
    [pageSize]="postCount()"
    [enableLoadMore]="false">
  </lib-social-wall>

  <button
    mat-flat-button
    class="button button--primary button--large social-wall-widget__see-all"
    data-cy="social-wall-widget-see-all"
    (click)="seeAllPosts.emit(selectedChannel()?.id)">
    {{ 'SOCIAL_WALL.see_all_posts' | translate }}
  </button>

</div>
